module.exports = __webpack_public_path__ + "static/media/copy.ed3b04c8.svg";